module.exports = __webpack_public_path__ + "static/media/csv.992a3c50.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svgicons/csv.svg
// module id = 1061
// module chunks = 0